<script>

import zxcvbn from 'zxcvbn'
import { mapActions, mapGetters } from 'vuex';
import {extensionHomeRoute} from "@/services/BrowserExtension";
import {isBrowserExtension} from "@/services/Context";

export default {
    props : {
        iToken: {type: String, default: ''},
        redirect: {type: Boolean, default: true}
    },
    data(){
        return {
            password : '',
            name : '',
            email : '',
            du: '',
            newPassword : '',
            networkActivity : false,
            errorMessage : false,
        }
    },
    computed : {
        goodPassword(){
            return zxcvbn(this.password).score > 2
        },
        passesValidation(){
            return this.goodPassword && this.name && this.email
        },
        accountTopics(){
            if (this.currentAccountOverview) {
                console.log('* Base.vue accountTopics this.topics', this.topics)
                return this.currentAccountOverview.topics
            }

            return [];
        },
        ...mapGetters({
            currentTopic: 'currentTopic',
            currentCollection: 'currentCollection',
            currentAccountOverview: 'currentAccountOverview',
            topics: 'topics',
            signupPlan: 'signupPlan',
            readyForLogin: 'readyForLogin',
        })
    },
    mounted(){
        if (this.iToken){
            this.setInviteToken({token: this.iToken});
        } else {
            this.setInviteToken({token: false});
        }
    },
    watch: {
        readyForLogin(newVal) {
            if (newVal && this.currentAccountOverview && this.$route.path === "/login") {
                console.log('* readyForLogin watcher triggered')
                this.loadSetCurrentAccountOverview();
            }
        }
    },
    methods : {
        ...mapActions({
            setToken : 'setAuthToken',
            setInviteToken : 'setInviteToken'
        }),
        updatePassword(){

            this.networkActivity = "Resetting password..."
            this.$api.put('/password', {
                new_password : this.newPassword,
                code : this.token
            })
            .then((response) => {
                this.networkMessage = "Done!"
                let token = response.data;
                setTimeout(() => {
                    this.logUserInWithToken(token);
                }, 500)
            })
            .catch(this.handleError);
        },
        logUserInWithToken(token){
            console.log('* Base.vue logUserInWithToken')
            this.setToken({token});

            this.networkActivity = "Syncing folders and topics..."
            this.$api.get('/profile').then(async resp => {
                let user = resp.data
                await this.$store.dispatch('userLoggedInWithToken', { user, token });
                console.time('timeToLogin');

                if (window.profitwell)
                    window.profitwell('start', { 'user_email': user.email })

            }).catch(this.handleError)
        },
        logIn(){
            console.log('* Base.vue LogIn')
            this.errorMessage = '';
            this.networkActivity = "Logging in..."
            this.$api.post('/sessions', this.$data).then(response => {
                let token = response.data;
                this.logUserInWithToken(token);

            }).catch(this.handleError)
        },
        loadCorrectLandingPage(){
            console.log('* Base.vue loadCorrectLandingPage')
            const topicCollectionRoute = '/'; //TODO: separate routes for topics and collections
            console.log('* Base.vue this.currentCollection', this.currentCollection)
            console.log('* Base.vue this.currentTopic', this.currentTopic)
            if(this.currentAccountOverview.collections.length > 0) {
                console.log('* Base.vue this.currentCollection', this.currentCollection)
                return topicCollectionRoute;
            } else if(this.currentAccountOverview.topics.length > 0) {
                console.log('* Base.vue this.currentTopic', this.currentTopic)
                return topicCollectionRoute;
            } else {
                return '/welcome';
            }
        },
        loadSetCurrentAccountOverview(){
            console.log('* Base.vue loadSetCurrentAccountOverview')

            console.log('* Base.vue this.currentAccountOverview', this.currentAccountOverview)
            console.log('* Base.vue this.$route.path', this.$route.path)
            console.log('* Base.vue this.readyForLogin', this.readyForLogin)
            if(this.currentAccountOverview) {
                this.networkActivity = "Initializing your account..."
            }
            if (this.currentAccountOverview && this.readyForLogin === true && this.$route.path === "/login") {
                console.log('* Base.vue isBrowserExtension() ', isBrowserExtension() )
                let route = isBrowserExtension() ? extensionHomeRoute() : this.loadCorrectLandingPage();
                console.log('* Base.vue route will be set:', route)
                if (this.redirect !== false)
                    this.$router.push(route);
                    console.timeEnd('timeToLogin');
                return;
            }

            if (this.$route.path !== "/login"){
                return;
            }


            setTimeout(() => {
                this.loadSetCurrentAccountOverview();
            }, 1000);


        },
        handleError(e){
            if (e.response && e.response.data){
                switch(e.response.status){
                    case 401:
                        this.errorMessage = "Incorrect password"
                    break;
                    default:
                        this.errorMessage = e.response.data.description
                    break;
                }


            }

            this.password = '';
            this.newPassword = '';
            this.networkActivity = false;

        },
        createAccount(){
            this.networkActivity = "Creating account..."
            this.$api.post('/users', {name : this.name, email: this.email, password : this.password})
            .then(response => {
                let token = response.data;
                this.setToken({token});
                this.networkActivity = "Planning your welcome party..."
                this.$api.get('/profile').then(resp => {
                    let user = resp.data

                    this.$gtm.trackEvent({
                        category: 'UserActivity',
                        event : 'Sign Up',
                        action: 'click',
                        label: 'New User Signed Up',
                        value: user.id
                    });

                    this.$ga.event({
                        eventCategory: 'UserActivity',
                        eventAction: 'Sign Up',
                        eventLabel: 'Sign Up',
                        eventValue: user.id
                    })

                    this.$store.dispatch('userLoggedInWithToken', { user, token })
                    this.registerSignupForReferral(user)
                    if (this.redirect !== false)
                        this.$router.push('/welcome')
                })
            })
            .catch(this.handleError)
        },
        registerSignupForReferral(user) {
            try {
                // eslint-disable-next-line no-undef
                $FPROM.trackSignup({
                    email: user.email,
                },() => {console.log(`Sign up logged for referral program (${user.email})`)});
            } catch (e) {
                console.error(e)
            }
        },
        sendResetEmail(){
            this.networkActivity = "Sending request for reset email..."
            this.$api.put('/password-reset', {email : this.email})
            .then(() => {
                this.networkActivity = 'Done! Check your email for the reset link';
            })
            .catch(this.handleError)
        }
    },
    render(h){
        return h()
    }
}
</script>
